import React from "react";
import "./ChartEmptyState.css";

const ChartEmptyState = ({
  title = "No data yet",
  message = "No matching data found",
}) => {
  return (
    <div className="chart-empty-state">
      <div className="chart-empty-state-icon" aria-hidden="true">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#9aa0a6"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="3" y1="21" x2="21" y2="21" />
          <polyline points="4 16 9 11 13 15 20 7" />
          <polyline points="15 7 20 7 20 12" />
        </svg>
      </div>
      <div className="chart-empty-state-title">{title}</div>
      <div className="chart-empty-state-message">{message}</div>
    </div>
  );
};

export default ChartEmptyState;
